var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": "storeIcon storeDesc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.773.29c.427 0 .8.191 1.045.5l1.577 3.501c.07.14.105.278.105.417v2.083c0 .582-.34 1.084-.833 1.318v4.932a.625.625 0 01-1.25 0V8.25h-3.75v3.813c0 .885-.653 1.603-1.459 1.603H2.792c-.806 0-1.459-.718-1.459-1.603V8.109A1.459 1.459 0 01.5 6.791V4.708a.93.93 0 01.103-.417l1.57-3.5c.254-.31.627-.5 1.054-.5h9.546zM14.045 7h-1.982V5.125h2.187V6.79a.208.208 0 01-.205.209zm-.208-3.125L12.785 1.54H3.227l-.021.001L2.16 3.875h11.677zm-5.212 1.25h2.188V7H8.624V5.125zm-1.25 0H5.187V7h2.188V5.125zm-3.438 0H1.75V6.79c0 .116.093.209.208.209h1.98V5.125zM2.583 8.273h5.834v3.79c0 .22-.122.353-.209.353H2.792c-.087 0-.209-.133-.209-.353v-3.79z",
    fill: "inherit"
  })));
}

export default SvgStore;